module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start-xs"
  }, [_c('pl-dialog', {
    attrs: {
      "title": _vm.optionalText,
      "size": 'relative',
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('body', {
    staticClass: "px-7 pt-7 pb-4 flex-grow overflow-y-auto"
  }, [_c('div', {
    staticClass: "flex justify-center mb-4"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-exclamation text-red-500 text-4xl"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mb-8"
  }, [_c('p', {
    staticClass: "text-center px-24"
  }, [_vm._v(_vm._s(_vm.subHeader))])]), _vm._v(" "), _c('div', {
    staticClass: "px-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirm),
      expression: "confirm"
    }],
    staticClass: "bg-input text-sm text-gray-600 flex-grow border border-solid focus:border-red-500 px-3 py-2 w-full rounded placeholder-gray-400",
    attrs: {
      "placeholder": _vm.labelText
    },
    domProps: {
      "value": (_vm.confirm)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitConfirm.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-xs ml-2 mt-1",
    class: _vm.errorMessage !== 'No Error' ? 'text-red-500' : 'text-white'
  }, [_vm._v("\n          " + _vm._s(_vm.errorMessage) + "\n        ")])])]), _vm._v(" "), _c('footer', {
    staticClass: "flex my-8 center items-center"
  }, [_c('button', {
    staticClass: "bg-gray-200 hover:bg-gray-300 py-2 px-5 text-gray-700 rounded mr-3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "py-2 px-5 text-white rounded",
    class: _vm.confirmColor,
    on: {
      "click": _vm.submitConfirm
    }
  }, [_vm._v("\n        " + _vm._s(_vm.submitButton) + "\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-633efa30!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/dialogDeleteConfirm.vue
// module id = 1031
// module chunks = 61